"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require("react-router-dom");

var _Editor = require("./Editor/Editor");

var _Editor2 = _interopRequireDefault(_Editor);

var _Visor = require("./Visor/Visor");

var _Visor2 = _interopRequireDefault(_Visor);

var _Gestor = require("./Gestor/Gestor");

var _Gestor2 = _interopRequireDefault(_Gestor);

var _Llistat = require("./LListat/Llistat");

var _Llistat2 = _interopRequireDefault(_Llistat);

var _ErrorPage = require("./ErrorPage/ErrorPage");

var _ErrorPage2 = _interopRequireDefault(_ErrorPage);

var _Login = require("./Login/Login");

var _Login2 = _interopRequireDefault(_Login);

var _withTracker = require("./withTracker");

var _withTracker2 = _interopRequireDefault(_withTracker);

var _App = require("./App.css");

var _App2 = _interopRequireDefault(_App);

var _reactGa = require("react-ga");

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //      


var App = function (_PureComponent) {
	_inherits(App, _PureComponent);

	function App() {
		_classCallCheck(this, App);

		return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	}

	_createClass(App, [{
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				_reactRouterDom.HashRouter,
				null,
				_react2.default.createElement(
					"div",
					{ className: _App2.default.myApp },
					_react2.default.createElement(
						_reactRouterDom.Switch,
						null,
						_react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/llistat", component: _Llistat2.default }),
						_react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/visor/:id", component: (0, _withTracker2.default)(_Visor2.default) }),
						_react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/visor/:orga/:id", component: (0, _withTracker2.default)(_Visor2.default) }),
						_react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/editor/:id", component: (0, _withTracker2.default)(_Editor2.default) }),
						_react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/editor/:orga/:id", component: (0, _withTracker2.default)(_Editor2.default) }),
						_react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/editor", component: (0, _withTracker2.default)(_Editor2.default) }),
						_react2.default.createElement(_reactRouterDom.Route, { path: "/login", component: (0, _withTracker2.default)(_Login2.default) }),
						_react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/gestor", component: (0, _withTracker2.default)(_Gestor2.default) }),
						_react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: "/", to: "/llistat" }),
						_react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: "/visor", to: "/llistat" }),
						_react2.default.createElement(_reactRouterDom.Redirect, { exact: true, from: "/visor/", to: "/visor" }),
						_react2.default.createElement(_reactRouterDom.Route, { component: _ErrorPage2.default })
					)
				)
			);
		}
	}]);

	return App;
}(_react.PureComponent);

exports.default = App;
